import Grid from '@mui/material/Grid';
import { useTheme } from '@mui/material/styles';
import type { FunctionComponent } from 'react';

import { SkillFilterChip } from './SkillFilterChip';

type SkillListProps = {
    readonly label: string;
    readonly onRemoveSkill: (skillId: string) => void;
    readonly skillIds: readonly string[];
};

export const SkillList: FunctionComponent<SkillListProps> = ({ label, onRemoveSkill, skillIds }) => {
    const theme = useTheme();

    return (
        <Grid>
            {label}
            {skillIds.map((id) => (
                <Grid
                    key={id}
                    sx={{
                        alignItems: 'center',
                        borderBottom: '1px solid',
                        borderBottomColor: 'cardborder.main',
                        display: 'grid',
                        paddingBlock: theme.spacing(0.8),
                        paddingInline: theme.spacing(3),
                    }}
                >
                    <SkillFilterChip id={id} onRemoveSkill={onRemoveSkill} />
                </Grid>
            ))}
        </Grid>
    );
};
